import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-761f2da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "ModalEditarLubrificante",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "exampleModalLongTitle"
  }, "Editar Lubrificante"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_6 = {
  class: "modal-body",
  id: "modalBody"
}
const _hoisted_7 = { class: "card d-flex flex-row mb-4" }
const _hoisted_8 = {
  class: "card w-100 justify-content-between pt-0 pb-0",
  id: "cardVeiculo"
}
const _hoisted_9 = {
  class: "card w-100 justify-content-between p-6",
  id: "cardProduto"
}
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = {
  key: 0,
  class: "text-danger fs-6"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Marca "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_15 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Viscosidade "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_17 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Produto "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_19 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, [
  /*#__PURE__*/_createTextVNode(" Tipo "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " * ")
], -1))
const _hoisted_21 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "API", -1))
const _hoisted_23 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "ACEA", -1))
const _hoisted_25 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "ILSAC", -1))
const _hoisted_27 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Combustível", -1))
const _hoisted_29 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Volks", -1))
const _hoisted_31 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Fiat", -1))
const _hoisted_33 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Chrysler", -1))
const _hoisted_35 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Ford", -1))
const _hoisted_37 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma GM", -1))
const _hoisted_39 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma BMW", -1))
const _hoisted_41 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Mercedes", -1))
const _hoisted_43 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Renault", -1))
const _hoisted_45 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma PSA", -1))
const _hoisted_47 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Norma Jaguar/Land Rover", -1))
const _hoisted_49 = { class: "col-sm-12 col-lg-4 col-xl-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Correspondência", -1))
const _hoisted_51 = { class: "col-12" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Descrição", -1))
const _hoisted_53 = {
  class: "col-12",
  style: {"position":"relative"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mt-4 texto" }, "Imagem", -1))
const _hoisted_55 = {
  class: "shadow-sm d-flex justify-content-center rounded",
  style: {"background-color":"#dedede"}
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_374_1959)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M23.194 21.9467H2.88147C1.58704 21.9467 0.53772 20.8973 0.53772 19.6029V5.54041C0.53772 4.24597 1.58704 3.19666 2.88147 3.19666H23.194C24.4884 3.19666 25.5377 4.24597 25.5377 5.54041V19.6029C25.5377 20.8973 24.4884 21.9467 23.194 21.9467ZM6.00647 5.93103C4.49631 5.93103 3.27209 7.15525 3.27209 8.66541C3.27209 10.1756 4.49631 11.3998 6.00647 11.3998C7.51663 11.3998 8.74084 10.1756 8.74084 8.66541C8.74084 7.15525 7.51663 5.93103 6.00647 5.93103ZM3.66272 18.8217H22.4127V13.3529L18.1395 9.07971C17.9107 8.8509 17.5397 8.8509 17.3109 9.07971L10.694 15.6967L7.98328 12.986C7.75447 12.7572 7.38347 12.7572 7.15461 12.986L3.66272 16.4779V18.8217Z",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_374_1959" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "25",
          height: "25",
          fill: "white",
          transform: "translate(0.53772 0.0716553)"
        })
      ])
    ])
  ])
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "imagem-edit",
  style: {"cursor":"pointer"}
}, "Enviar arquivo", -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = {
  key: 0,
  class: "nome-arquivo"
}
const _hoisted_60 = {
  class: "col-12 d-flex justify-content-end mt-4",
  id: "btn-group"
}
const _hoisted_61 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_66 = [
  _hoisted_65
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_ctx.spanWarning == true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Preencha todos os campos obrigatorios "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_el_select, {
                          placeholder: "Marca",
                          type: "text",
                          clearable: "",
                          filterable: "",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3","width":"100%"},
                          modelValue: _ctx.lubForm.marca,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lubForm.marca) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marcasDeLubrificantes, (marcaProd, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: key,
                                label: marcaProd.nome,
                                value: marcaProd.id_marca_produto.toString()
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_el_input, {
                          placeholder: "Viscosidade",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.viscosidade,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lubForm.viscosidade) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_el_input, {
                          placeholder: "Produto",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.produto,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lubForm.produto) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.lubForm.tipo,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lubForm.tipo) = $event)),
                          placeholder: "Selecione um tipo para pesquisa",
                          clearable: "",
                          style: {"border":"1px solid rgb(181, 181, 195)","border-radius":"5px","width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Semisintetico",
                              value: "semisintetico"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Sintetico",
                              value: "sintetico"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Mineral",
                              value: "mineral"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_el_input, {
                          placeholder: "API",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.api,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.lubForm.api) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_el_input, {
                          placeholder: "ACEA",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.acea,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.lubForm.acea) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_el_input, {
                          placeholder: "ILSAC",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.ilsac,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.lubForm.ilsac) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_el_select, {
                          placeholder: "Combustível",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3","width":"100%"},
                          modelValue: _ctx.lubForm.combustivel,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lubForm.combustivel) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Gasolina",
                              value: "gasolina"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Alcool",
                              value: "alcool"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Diesel",
                              value: "diesel"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Volks",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_vw,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.lubForm.norma_vw) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Fiat",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_fiat,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.lubForm.norma_fiat) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Chrysler",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_chrysler,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.lubForm.norma_chrysler) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Ford",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_ford,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.lubForm.norma_ford) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma GM",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_gm,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.lubForm.norma_gm) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma BMW",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_bmw,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.lubForm.norma_bmw) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Mercedes",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_mercedes,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.lubForm.norma_mercedes) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Renault",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_renault,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.lubForm.norma_renault) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma PSA",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_psa,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.lubForm.norma_psa) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createVNode(_component_el_input, {
                          placeholder: "Norma Jaguar/Land Rover",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.norma_jaguar_land_rover,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.lubForm.norma_jaguar_land_rover) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _createVNode(_component_el_input, {
                          placeholder: "Correspondência",
                          clearable: "",
                          type: "text",
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.correspondencia,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.lubForm.correspondencia) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createVNode(_component_el_input, {
                          placeholder: "Descrição do produto",
                          type: "textarea",
                          rows: 6,
                          autosize: { minRows: 6, maxRows: 6 },
                          style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
                          modelValue: _ctx.lubForm.descricao,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.lubForm.descricao) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_el_image, {
                            src: _ctx.lubForm.imagemPreview || _ctx.lubForm.imagem,
                            fit: "contain",
                            style: {"display":"flex","justify-content":"center","align-items":"center","height":"138px"}
                          }, {
                            error: _withCtx(() => [
                              _hoisted_56
                            ]),
                            _: 1
                          }, 8, ["src"])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light-danger send-file",
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.openFileDialog && _ctx.openFileDialog(...args)))
                        }, _hoisted_58),
                        _createElementVNode("input", {
                          type: "file",
                          ref: "imagem-edit",
                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleImgFileChange($event))),
                          name: "imagem",
                          id: "imagem-edit",
                          class: "select-file"
                        }, null, 544)
                      ]),
                      (_ctx.fileName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.fileName), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_Button, {
                          type: "submit",
                          variant: "primary",
                          text: "Salvar",
                          onClick: _ctx.onSave
                        }, {
                          default: _withCtx(() => [
                            (_ctx.loadSalvar)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63))
                              : (_openBlock(), _createElementBlock("svg", _hoisted_64, _hoisted_66))
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}